var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 15.75C5.80964 15.75 5.25 16.3096 5.25 17C5.25 17.6904 5.80964 18.25 6.5 18.25C7.19036 18.25 7.75 17.6904 7.75 17C7.75 16.3096 7.19036 15.75 6.5 15.75ZM3.75 17C3.75 15.4812 4.98122 14.25 6.5 14.25C8.01878 14.25 9.25 15.4812 9.25 17C9.25 18.5188 8.01878 19.75 6.5 19.75C4.98122 19.75 3.75 18.5188 3.75 17Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 15.75C16.8096 15.75 16.25 16.3096 16.25 17C16.25 17.6904 16.8096 18.25 17.5 18.25C18.1904 18.25 18.75 17.6904 18.75 17C18.75 16.3096 18.1904 15.75 17.5 15.75ZM14.75 17C14.75 15.4812 15.9812 14.25 17.5 14.25C19.0188 14.25 20.25 15.4812 20.25 17C20.25 18.5188 19.0188 19.75 17.5 19.75C15.9812 19.75 14.75 18.5188 14.75 17Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 1C0.75 0.585786 1.08579 0.25 1.5 0.25H3.5C3.85365 0.25 4.15925 0.49705 4.23335 0.842853L7.10631 14.25H17.5C17.9142 14.25 18.25 14.5858 18.25 15C18.25 15.4142 17.9142 15.75 17.5 15.75H6.5C6.14635 15.75 5.84075 15.5029 5.76665 15.1571L2.89369 1.75H1.5C1.08579 1.75 0.75 1.41421 0.75 1Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75149 2.95324C3.77732 2.53983 4.1334 2.22565 4.54681 2.25149L20.5468 3.25149C20.7557 3.26454 20.9496 3.36426 21.0817 3.52654C21.2138 3.68883 21.2721 3.89893 21.2425 4.10609L20.2425 11.1061C20.1897 11.4756 19.8733 11.75 19.5 11.75H6.50003C6.08581 11.75 5.75003 11.4142 5.75003 11C5.75003 10.5858 6.08581 10.25 6.50003 10.25H18.8496L19.6427 4.69791L4.45324 3.74856C4.03983 3.72273 3.72565 3.36665 3.75149 2.95324Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.fa040ead1b3e303c7caa00d5a2532f39.svg";
export { ForwardRef as ReactComponent };